import { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";

interface SelectFieldProps {
    label: string;
    options: string[];
    value: string;
    name: string;
    onChange: (name: string, value: string) => void;
}

const SelectField = ({ label, options, value = "", name, onChange }: SelectFieldProps) => {
    const [selectWidth, setSelectWidth] = useState(0);
    const [showOptions, setShowOptions] = useState(false);
    const selectRef = useRef<HTMLDivElement>(null);

    const handleSelectChange = (selectedValue: string) => {
        setShowOptions(false);
        onChange(name, selectedValue);
    };

    const handleOutsideClick = (e: MouseEvent) => {
        if (selectRef.current && !selectRef.current.contains(e.target as Node)) {
            setShowOptions(false);
        }
    };

    const updateSelectWidth = () => {
        if (selectRef?.current) {
            setSelectWidth(selectRef.current.offsetWidth);
        }
    };

    useEffect(() => {
        updateSelectWidth()
    }, []);

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    return (
        <div className={styles.selectContainer} style={{ maxWidth: selectWidth ? `${selectWidth}px` : "" }}>
            <div className={styles.label}>{label}</div>
            <div
                className={styles.customSelect}
                onClick={() => setShowOptions(!showOptions)}
                ref={selectRef}>
                <div className={styles.selectedValue}>
                    {value}
                </div>
                {showOptions && (
                    <div className={styles.optionsList}>
                        {options.map((option, index) => (
                            <div
                                key={index}
                                className={styles.option}
                                onClick={() => handleSelectChange(option)}
                            >
                                {option}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div >
    );
};

export default SelectField;